import React from "react";

const Filter2FillIcon = () => (
	<g>
		<path d='M10 14L4 5V3H20V5L14 14V20L10 22V14Z' />
	</g>
);

export default Filter2FillIcon;
